import React, { useState, useEffect } from 'react'
import { useActivity } from '../../Component/context_components/activities_context'
import Black_Arrow from '../../Assets/Icons/Black_Arrow.svg'
import ImageCarosel from '../../Component/Carosel/Image_Carosel'
import ExpandableText from '../../Pages/HS/ExpandableText'
import moment from 'moment'
import {
  Grid,
  Typography,
  CardActionArea,
  Card,
  CardContent,
  Button,
  Dialog,
  DialogTitle,
  CardActions,
  DialogContent,
  DialogActions,
  Autocomplete,
  TextField,
  Container,
  useMediaQuery,
  CircularProgress,
} from '@mui/material'

const Activity = () => {
  const { activitiesData, yearsData } = useActivity()
  const [filter_date, setfilter_date] = useState('')
  const [Filter_Data, setFilter_data] = useState([]) // Initialize as empty array
  const [selectedImage, setSelectedImage] = useState(null)
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const isMobile = useMediaQuery('(max-width:600px)')

  // Initialize and filter data when activitiesData changes
  useEffect(() => {
    if (activitiesData && Array.isArray(activitiesData)) {
      setFilter_data(activitiesData)
      setIsLoading(false)
    } else {
      setFilter_data([]) // Ensure it's always an array
      setIsLoading(false)
    }
  }, [activitiesData])

  // Handle year filter changes
  const handleYearChange = (event, newValue) => {
    setfilter_date(newValue === 'All' ? '' : newValue)
    if (newValue === 'All' || !newValue) {
      setFilter_data(Array.isArray(activitiesData) ? activitiesData : [])
    } else {
      const filtered_data = (
        Array.isArray(activitiesData) ? activitiesData : []
      ).filter(
        (item) =>
          item &&
          item.date &&
          moment(item.date).year().toString() === newValue.toString()
      )
      setFilter_data(filtered_data)
    }
  }

  if (isLoading) {
    return (
      <Container sx={{ py: 4, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Container>
    )
  }

  return (
    <section>
      <Container sx={{ py: 4 }}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs={12} sm="auto">
            <Typography
              variant="h5"
              sx={{ fontSize: { xs: '18px', sm: '24px' } }}
            >
              Events And Activities
            </Typography>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Autocomplete
              options={['All', ...(Array.isArray(yearsData) ? yearsData : [])]}
              getOptionLabel={(option) => option.toString()}
              value={filter_date || 'All'}
              onChange={handleYearChange}
              renderInput={(params) => (
                <TextField {...params} label="Select Year" variant="standard" />
              )}
              sx={{ minWidth: 150 }}
            />
          </Grid>
        </Grid>

        {!Array.isArray(Filter_Data) || Filter_Data.length === 0 ? (
          <Typography variant="body1" sx={{ my: 4, textAlign: 'center' }}>
            {Array.isArray(activitiesData) && activitiesData.length > 0
              ? 'No data found for selected year.'
              : 'No activities data available.'}
          </Typography>
        ) : (
          <Grid container spacing={3} sx={{ py: 4 }}>
            {Filter_Data.map((item, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={index}
                sx={{ display: 'flex' }}
              >
                <Card
                  sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    minHeight: '360px',
                    boxShadow: 3,
                  }}
                >
                  <CardActionArea
                    onClick={() => {
                      setSelectedImage(item)
                      setIsDialogOpen(true)
                    }}
                  >
                    <ImageCarosel image_data={item.image_urls || []} />
                    <CardContent sx={{ flexGrow: 1, minHeight: '150px' }}>
                      <Typography
                        variant="h6"
                        sx={{ fontSize: { xs: '16px', md: '18px' } }}
                      >
                        {item.heading || 'No title'}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          display: '-webkit-box',
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {item.description || 'No description available'}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions
                    sx={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <Button size="small">{item.date || 'No date'}</Button>
                    <img
                      src={Black_Arrow}
                      loading="lazy"
                      placeholder="blur"
                      alt="Arrow"
                    />
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>

      {/* Dialog for Image Details */}
      <Dialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        maxWidth={isMobile ? 'xs' : 'sm'}
        fullWidth
        sx={{
          '& .MuiDialog-paper': { borderRadius: '12px', padding: '16px' },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            {selectedImage?.heading || 'Event Details'}
          </Typography>
          <Button onClick={() => setIsDialogOpen(false)} sx={{ minWidth: 0 }}>
            ✖
          </Button>
        </DialogTitle>

        {selectedImage && (
          <DialogContent
            dividers
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                width: '100%',
                maxHeight: '300px',
                overflow: 'hidden',
                borderRadius: '8px',
              }}
            >
              <ImageCarosel
                isDialogOpen={isDialogOpen}
                image_data={selectedImage.image_urls || []}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>

            <ExpandableText
              text={selectedImage.description || 'No description available'}
              initialChars={120}
              showFullText={false}
            />
          </DialogContent>
        )}

        <DialogActions sx={{ justifyContent: 'center', paddingBottom: '12px' }}>
          <Button
            onClick={() => setIsDialogOpen(false)}
            variant="contained"
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </section>
  )
}

export default Activity
